import React from 'react';
import {useTranslation} from 'react-i18next';
import {Dialog, Divider, Text, Layout, IconButton, CloseIcon} from '@phonectas/unifon-ui-kit';
import {StyledCancelButton} from './styled';

interface CancelDialogProps {
	id?: string;
	handleChange: () => void;
	close: () => void;
	open?: boolean;
}

const CancelDialog: React.FC<CancelDialogProps> = ({id = '', handleChange, close, open = false}) => {
	const [t] = useTranslation();
	return (
		<Dialog
			show={open}
			onClose={close}
			style={{width: '413px', padding: '16px'}}
		>
			<Layout>
				<Layout fullWidth nowrap justifyContent="space-between" alignItems="center">
					<Text>
						{t('Confirm cancellation of {{id}}', {id: id})}
					</Text>
					<IconButton onClick={close}>
						<CloseIcon />
					</IconButton>

				</Layout>
				<Divider />
				<StyledCancelButton compact fullWidth onClick={close}>{t('No')}</StyledCancelButton>
				<StyledCancelButton compact color="error" fullWidth onClick={handleChange}>{t('Yes')}</StyledCancelButton>
			</Layout>
		</Dialog>
	);
}

export default CancelDialog;
